import React from "react";
import "./works.css";
import pergulaImage1 from "../../media/images/pergulaImage1.jpg";
import pergulaImage2 from "../../media/images/pergulaImage2.jpg";
import pergulaImage3 from "../../media/images/pergulaImage3.jpg";
import pergulaImage4 from "../../media/images/pergulaImage4.jpg";
import pergulaImage5 from "../../media/images/pergulaImage5.jpg";
import video1 from "../../media/images/video1.mp4";
import video2 from "../../media/images/video2.mp4";
import video3 from "../../media/images/video3.mp4";
import video4 from "../../media/images/video4.mp4";

import Corusle from "./Corusle.jsx";

const Works = () => {
    const works = [
        {
            name: "פרגולות",
            id: "carouselPergulas", // Unique ID
            images: [
                pergulaImage1,
                pergulaImage2,
                pergulaImage3,
                pergulaImage4,
                pergulaImage5,
            ],
        } /* ,
        {
            name: "מרפסות",
            id: "carouselPorches", // Unique ID
            images: [pergulaImage, porchImage, fenceImage, deckImage],
        },
        {
            name: "גדרות",
            id: "carouselFences", // Unique ID
            images: [pergulaImage, porchImage, fenceImage, deckImage],
        },
        {
            name: "דקים",
            id: "carouselDecks", // Unique ID
            images: [pergulaImage, porchImage, fenceImage, deckImage],
        }, */,
    ];
    const videos = [
        {
            name: "סרטונים",
            id: "carouselVideos", // Unique ID
            srcs: [video1, video2, video3, video4],
        },
    ];
    return (
        <section id="works">
            <h1 className="head">העבודות שלנו</h1>
            {works.map((work, index) => (
                <div key={work.id}>
                    <h2>{work.name}</h2>
                    <Corusle images={work.images} carouselId={work.id} />
                </div>
            ))}
            {videos.map((vid, index) => (
                <div key={vid.id}>
                    <h2>{vid.name}</h2>
                    <Corusle videos={vid.srcs} carouselId={vid.id} />
                </div>
            ))}
        </section>
    );
};

export default Works;
